module.exports = __webpack_public_path__ + "static/media/Initiatives.dfae0a51.JPG";